import { environment } from "../../environments/environment";

export const API_URL = environment.API_URL;
export const STAGE = environment.stage;
export const ACCESS_TOKEN = 'accessToken';
export const REFRESH_TOKEN = 'refreshToken';
export const USER_DATA = 'userData';
export const PATH_LOGIN = '/auth/login';

export const GENEROS = ['Masculino', 'Femenino', 'Otro'];
export const CATEGORIAS_ESTABLECIMINETO = ['hotel', 'motel', 'apart-hotel'];
export const PLATAFORMAS = [{ id: 'backoffice', name: 'Backoffice' }, { id: 'anfitrion', name: 'Anfitrión' }];

export const REGEX = {
    email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    onlyNumbers: /^[0-9]*$/,
    rut: /^\d{1,2}\.\d{3}\.\d{3}[-][0-9kK]$/,
}